<template>
<div class="house-info-component">
  <el-dialog title="房产信息管理" :visible.sync="visible" width="80%" @close="onClose">
    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="房产信息" name="HouseTreeInfo">
        <HouseTreeInfo v-if="card_index==='HouseTreeInfo'" />
      </el-tab-pane>
<!--      <el-tab-pane label="房产信息" name="HouseInfo">-->
<!--        <HouseInfo v-if="card_index==='HouseInfo'" />-->
<!--      </el-tab-pane>-->
    </el-tabs>
  </el-dialog>
</div>
</template>

<script>
import HouseTreeInfo from "./HouseTreeInfo";
import HouseInfo from "./HouseInfo";
export default {
  name: "HouseInfoComponent",
  components: {HouseInfo, HouseTreeInfo},
  provide(){
    return{
      mainData:this.mainData
    }
  },
  data(){
    return{
      card_index:"HouseTreeInfo",
      visible:false,
      mainData:{
        house_tree:{},
        house:{}
      }
    }
  },
  mounted() {
  },
  methods:{
    show(item){
      this.mainData.house=this.defaultHouse(item.house);
      let house_tree=item;
      delete house_tree.house;
      delete house_tree.customer;
      this.mainData.house_tree=this.defaultHouseTree(house_tree);
      this.visible=true;
    },
    onClose(){
      this.mainData.house={};
      this.mainData.house_tree={}
      this.visible=false;
    },
    defaultHouse(house) {
      return Object.assign({
        id: null,
        company_id: null,
        pindex_id: null,
        jurisdiction_id: null,
        number: null,
        name: null,
        identification_card: null,
        phone: null,
        gender: null,
        emergency_contact: null,
        theElderly: null,
        theElderly_name: null,
        children: null,
        children_name: null,
        type: null,
        customer_nature: null,
        area: null,
        dwelling_space: null,
        charging: null,
        garden: null,
        share: null,
        delivery_date: null,
        standard: null,
        cycle: null,
        cost: null,
        house_type: null,
        sales_status: null,
        subscription_date: null,
        payment_method: null,
        number_of_periods: null,
        community_name: null,
        address: null,
        parking_lot: null,
        car_area_no: null,
        parking: null,
        region: null,
        villa: null,
        building: null,
        unit: null,
        room: null,
        date: null,
        xsc_precinctID: null,
        xsc_id: null,
        RoomStatus: null,
        RoomStatusName: '',
        room_status: '',
        room_status_ids: '',
        room_status_name: '',
        BelongFloor: null,
        xsc_HouseName: null,
        customer_id: 0,
        status: 2,
        project_type: null,
        yc_id: null,
        merge_id: null
      }, house);
    },
    defaultHouseTree(house_tree) {
      return Object.assign({
        house_id: null,
        parent_id: null,
        project_house_id: null,
        area_id: null,
        house_name: null,
        ancestor_ids: null,
        ancestor_name: null,
        level: null,
        deepest_node: null,
        show_status: 0,
        erp_pindex_id: null,
        erp_house_id: null,
        updated_at: null,
        number: null,
        belong_floor: null,
        yard: null,
        butler_region_id: 0,
        host_precinct_id: null,
        host_house_id: null,
        xsc_pindex_id: null,
        xsc_house_id: null,
        status: 2,
        weight: 0,
        order_str: null,
        ancestor_id: null,
        account_str: null,
        xsc_area_id: null,
        type: 88,
        order_str_weight: null,
        merge_id: null
      }, house_tree);
    }
  }

}
</script>

<style lang="scss" scoped>
.house-info-component{
  //>>>.el-dialog__header{
  //  display: none;
  //}
  >>>.el-dialog__body{
    padding-top: 5px;
    padding-right: 2px;
    padding-left: 2px;
    padding-bottom: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/components/HouseInfoComponent.vue